const EQUIPMENTS_TABLE_READY = "equipments-table-ready"
const SEARCH_TEXT_STATE = "equipments-table-search-text-state"
const ROWS_PER_PAGE_STATE = "equipments-table-rows-per-page-state"
const PAGINATION_STATE = "equipments-table-pagination-state"

const EQUIPMENT_ID_FOR_ACTION = "equipments-table-equipment-id-for-action"

const ADD_EDIT_EQUIPMENT_READY = "add-edit-equipment-ready"


const PREVIOUS_EQUIPMENT_FILTER_STATUS = "previous-equipment-filter-status-action"

const PREVIOUS_EQUIPMENT_FILTER_VENDOR_ID = "previous-equipment-filter-vendor-id-action"


const PREVIOUS_EQUIPMENTS_WORK_LOCATION_TYPE = "equipments-previous-work-location-type"
const PREVIOUS_EQUIPMENTS_WORK_LOCATION_ID = "equipments-previous-work-location-id"



const initialState = {
    isEquipmentsTableReady: true,
    isAddEditEquipmentReady:true,
    equipments: {},

    
    equipmentSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterStatus : "",
    previousFilterVendor : "",


    previousWorkLocationType: "",
    previousWorkLocationId: "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case EQUIPMENTS_TABLE_READY:
            return Object.assign({}, state, { isEquipmentsTableReady: action.payload })
        case ADD_EDIT_EQUIPMENT_READY:
            return Object.assign({}, state, { isAddEditEquipmentReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case EQUIPMENT_ID_FOR_ACTION:
            return Object.assign({}, state, {equipmentSelectedId:action.payload})

        case PREVIOUS_EQUIPMENT_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        case PREVIOUS_EQUIPMENT_FILTER_VENDOR_ID:
            return Object.assign({}, state, {previousFilterVendor:action.payload})



        case PREVIOUS_EQUIPMENTS_WORK_LOCATION_TYPE:
            return Object.assign({}, state, {previousWorkLocationType:action.payload})
        case PREVIOUS_EQUIPMENTS_WORK_LOCATION_ID:
            return Object.assign({}, state, {previousWorkLocationId:action.payload})


        default:
        return state
    
    }

}

export function equipmentsTableReady(data) {
    return {
        type: EQUIPMENTS_TABLE_READY,
        payload: data
    }
}


export function addEditEquipmentReady(data) {
    return {
        type: ADD_EDIT_EQUIPMENT_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function equipmentIdForAction(equipmentId){
    return{
        type:EQUIPMENT_ID_FOR_ACTION,
        payload:equipmentId
    }
}

export function previousFilterStatus(filterVal){
    return{
        type:PREVIOUS_EQUIPMENT_FILTER_STATUS,
        payload:filterVal
    }
}


export function previousFilterVendor(filterVal){
    return{
        type:PREVIOUS_EQUIPMENT_FILTER_VENDOR_ID,
        payload:filterVal
    }
}


export function previousWorkLocationType(fiter_val){
    return{
        type:PREVIOUS_EQUIPMENTS_WORK_LOCATION_TYPE,
        payload:fiter_val
    }
}


export function previousWorkLocationId(fiter_val){
    return{
        type:PREVIOUS_EQUIPMENTS_WORK_LOCATION_ID,
        payload:fiter_val
    }
}



// WEBPACK FOOTER //
// ./src/modules/Equipments/redux/equipments.js